module.exports = __webpack_public_path__ + "img/COLLAR GREEN.479fc57.svg";